import { deletedata } from '@/util/global';
import React from 'react';

const DashboardTableBill = ({ billdata}) => {
  const rows = [];

  for (let i = 0; i < billdata.length; i++) {
    const a = billdata[i];
    rows.push(
      <tr key={a._id || i}>
        <td>
          <a href={`https://books.zoho.in/app/60022040726#/bills/${a.bill_id}?filter_by=Status.All&per_page=200&sort_column=created_time&sort_order=D`} target="_blank">view bill</a>
        </td>
        <td>{a.date}</td>
        <td>{a.vendor_name}</td>
        <td>{a.created_by}</td>
        <td>{a.last_modified_by}</td>
        <td>{a.status}</td>

      </tr>
    );
  }

  return (
    <table className="grid" >
      <thead>
        <tr><th style={{width:'30px'}}>action</th><th>date</th><th>vendor name</th><th>created by</th><th>modified by</th><th>status</th></tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default DashboardTableBill;